import { AppAction, PageFilter } from '../../../../state/app';

export const FETCH_PENDING_APPROVAL_SAMPLE_DEV_NL_LIST =
  'FETCH_PENDING_APPROVAL_SAMPLE_DEV_NL_LIST';

export const fetchPendingApprovalSampleDevNlList = (paging: PageFilter): AppAction => {
  return {
    type: FETCH_PENDING_APPROVAL_SAMPLE_DEV_NL_LIST,
    payload: {
      filters: { 'HasResponded.EqualsTo': 'false' },
      paging,
    },
  };
};
